import { graphql } from "gatsby";
import React from "react";
import xss from "xss";
import { SEO } from "../components/SEO";

import SubPage from "../components/SubPage";

const Template = ({ data }: { data: any }) => {
  const { html } = data.markdownRemark;

  return (
    <SubPage>
      <SEO title={data.markdownRemark.frontmatter.title} description={html}/>
      <div dangerouslySetInnerHTML={{ __html: xss(html) }} />
    </SubPage>
  );
};

export default Template;

export const pageQuery = graphql`
  query ($slug: String!) {
    markdownRemark(frontmatter: { slug: { eq: $slug } }) {
      html
      frontmatter {
        date(formatString: "YYYY-MM-DD")
        slug
        title
      }
    }
  }
`;
